import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper from '../chart_helpers/AxisHelper'
import SizeHelper from '../chart_helpers/SizeHelper'
import { categoricalExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import { dentedRect } from '../utils/pathUtils'
// import { select as d3_select } from 'd3-selection'
// import { scaleBand as d3_scaleBand, scaleLinear as d3_scaleLinear } from 'd3-scale'

/* eslint-disable */

const MAX_BAR_WIDTH = 99
export default class PercentageBarChart extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = true
  }
  static defaultConfig = {
    /**
     * Minimum height of each bar (in pixels).
     */
    percentageMode: {
      type: [String],
      default: 'independent',
      options: ['aggregate', 'independent'],
      exposed: true,
    },
    dataSorting: {
      type: [String],
      default: 'none',
      options: ['none', 'asc', 'desc'],
      exposed: true,
    },
    minBarHeight: {
      type: [Number],
      default: 0,
      exposed: true,
    },
    horizontal: {
      type: Boolean,
      default: true,
      exposed: false,
      nonEditable: true,
    },
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    AxisHelper: {
      /**
       * Enable automatic scroll. If enabled, axes will be scrolalbel only if the number of bars is large enough.
       */
      zoom: {
        value: false,
        exposed: false,
        nonEditable: true,
      },
      x: {
        scale: {
          value: 'band',
          exposed: false,
          nonEditable: true,
        },
        side: {
          value: 'top',
          exposed: false,
          nonEditable: true,
        },
        showTickValues: {
          value: false,
          exposed: false,
          nonEditable: true,
        },
        tickOrientation: {
          exposed: false,
          nonEditable: true,
        },
        tickWrap: {
          exposed: false,
          nonEditable: true,
        },
        valueFormat: {
          exposed: false,
          nonEditable: true,
        },
        grid: {
          exposed: false,
          nonEditable: true,
        },
        unit: {
          exposed: false,
          nonEditable: true,
        },
        trimThreshold: {
          value: false,
          exposed: false,
          nonEditable: true,
        },
        getExtent: function (data) {
          return categoricalExtent(data)
        },
      },
      y: {
        side: {
          value: 'left',
          exposed: false,
          nonEditable: true,
        },
        showTickValues: {
          value: false,
          exposed: false,
          nonEditable: true,
        },
        scale: {
          value: 'linear',
          exposed: false,
          nonEditable: true,
        },
        tickOrientation: {
          exposed: false,
          nonEditable: true,
        },
        tickWrap: {
          exposed: false,
          nonEditable: true,
        },
        trimThreshold: {
          value: false,
          exposed: false,
          nonEditable: true,
        },
        getExtent: function (data) {
          // FIJAMOS 0,100 o no!?!?!
          return [0, 100]
          // let extent, extentParts
          // extentParts = continuousExtentParts(data, d => [d.y0, d.y1])
          // // console.log("extent parts",extentParts)
          // extent = continuousExtent(extentParts)

          // // console.log("bar extent bef",extent)
          // extent = cleanCollisions(this.axes.y, extent, extentParts)
          // // console.log("bar extent aft",extent)
          // return extent
        },
      },
    },
    TooltipBehavior: {
      getItemOffset: function ($el) {
        let original = $el.getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5,
        }
      },
      getHtml: function (d) {
        if (this.data.length > 1)
          return `
          <div class="tip-value important">${this.valueWithUnit(d.value, 'y')}</div>
          <div class="tip-id">
            <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
              { id: d.parentId }
            )}; margin-right: 3px"></span>
            ${d.parentId}
          </div>
          <div class="secondary">${this.formatValue(d.id, 'x')}</div>
            `
        else
          return `
        <div class="tip-value important">${this.valueWithUnit(d.value, 'y')}</div>
        <div class="secondary">
            ${d.id}
          </div>
        `
      },
    },
  }
  static helpers = [RootHelper, ItemsHelper, SelectableHelper, SizeHelper, AxisHelper]
  checkConsistency() {
    return true
  }
  beforeHelpers() {
    this.margin = { top: 20, right: 100, left: 20, bottom: 20 }
  }
  draw() {
    let longDir, getTranslate, getOffset, getShort //,shortDir

    // let yScale = d3_scaleLinear().domain([0, 100]).range([0, this.contentSize.width])
    // let xScale = d3_scaleBand()
    //   .domain(categoricalExtent(this.data))
    //   .range([0, this.contentSize.height])

    longDir = 'height'
    // shortDir = 'width'
    getTranslate = (long, short) => {
      return `translate(${short},${long})`
    }

    let offsetValue
    if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
      offsetValue = 0
    else offsetValue = this.axes.y.func.scale().domain()[0]

    getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
    getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)

    // let barPercent = 0.4
    // let barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.func.scale().bandwidth() * barPercent)
    let barWidth = this.axes.x.func.scale().bandwidth() - 22 - 8
    let barMargin = (this.axes.x.func.scale().bandwidth() - barWidth) / 2

    let drawItem
    let stackPadding = 2
    drawItem = (sel, status) => {
      sel.attr('transform', d => {
        let barPos
        if (status === 'enter' || status === 'exit') barPos = this.axes.y.func.scale()(0)
        else barPos = this.axes.y.func.scale()(this.config.horizontal ? d.y0 : d.y1)
        return getTranslate(
          this.axes.x.func.scale()(d.id) + barMargin,
          barPos + (this.config.horizontal ? 0 : stackPadding / 2)
        )
      })

      sel
        .select('.item-path')
        .attr('transform', `translate(0,10)`)
        .attr('fill', d => {
          if (d.parentId === '_total_')
            return this.config.skin === 'dark' ? 'rgb(68, 68, 68)' : 'rgb(246, 250, 252)'
          else return this.color({ id: d.parentId })
        })
        .attr('d', d => {
          let barLength
          if (status === 'enter' || status === 'exit') barLength = 0
          else
            barLength =
              getShort(this.axes.y.func.scale()(d.safeValue)) -
              (d.isFirstLayer ? stackPadding : stackPadding)
          barLength = Math.max(barLength, 0)
          let w = longDir === 'width' ? barWidth : barLength
          let h = longDir === 'width' ? barLength : barWidth

          //CUSTOMIZED:
          let dents = [d.isLastLayer ? 'br' : null, d.isFirstLayer ? 'tl' : null].filter(d => d)
          if (dents.length === 0) dents = 'none'
          return dentedRect(w, h, dents)
        })
    }

    let totalsData = this.data[0].value.map(d => {
      return {
        id: d.id,
        parentId: '_total_',
        y0: 0,
        y1: 100,
        value: 100,
        safeValue: 100,
        totalPercentage: d.layerTotal,
        totalAbs: d.layerTotalAbs,
      }
    })
    let totalsRoot = this.content.selectAll('.totals-layer').data([null])
    totalsRoot = totalsRoot.merge(totalsRoot.enter().append('g').attr('class', 'totals-layer'))
    totalsRoot.lower()
    let totalsItems = totalsRoot.selectAll('.total-item').data(totalsData, d => d.id)
    totalsItems.exit().remove()
    let totalsItemsEnter = totalsItems.enter().append('g').attr('class', 'total-item')
    totalsItemsEnter.append('path').attr('class', 'item-path')
    totalsItemsEnter.append('text').attr('class', 'label')
    totalsItemsEnter.append('text').attr('class', 'value')
    totalsItems = totalsItems.merge(totalsItemsEnter)
    totalsItems.call(drawItem)
    totalsItems
      .select('.label')
      .style('font-size', '16px')
      .style('fill', this.config.skin === 'dark' ? '#fff' : '#666')
      .text(
        d => d.id + (this.config.showDatumValues ? ` (${this.valueWithUnit(d.totalAbs, 'y')})` : '')
      )

    totalsItems
      .select('.value')
      // .text(d => parseFloat(d.totalPercentage).toFixed(2) + '%')
      .text(d => (this.formatValue(d.totalPercentage, 'y') + '%').replace('%%', '%'))
      .style('font-size', '18px')
      .style('font-weight', '300')
      .style('fill', this.config.skin === 'dark' ? '#fff' : '#222')
      .attr('transform', `translate(${this.size.width - 40},${10 + barWidth / 2})`)
      .attr('text-anchor', 'end')
      .attr('dominant-baseline', 'middle')

    this.itemsEnter.append('path').attr('class', 'item-path')
    // HAy que pintar lo "viejos" primero para assegurar que se mantiene el orden de colores...
    this.itemsTrans.call(drawItem)
    this.itemsEnter.call(drawItem, 'enter')
    this.itemsEnterTrans.call(drawItem)
    this.itemsExitTrans.style('opacity', 0)
    if (this.parentItemsExitTrans) this.parentItemsExitTrans.style('opacity', 0)
  }
}
